/* eslint-disable prefer-rest-params, prefer-spread, no-unused-expressions, no-multi-assign, no-var, vars-on-top */
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

declare const window: Window & {
  snaptr: any;
};

// <!-- Snap Pixel Code -->
if (!window.snaptr) {
  var a: any = (window.snaptr = function snaptr() {
    a.handleRequest
      ? a.handleRequest.apply(a, arguments)
      : a.queue.push(arguments);
  });
  a.queue = [];
}

export function loadSnapchat() {
  return loadScript("https://sc-static.net/scevent.min.js", [
    LibCategories.targetingCookies,
  ]);
}
